import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['DriverMessages'],
});
export const driverMessagesApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllDriverMessages: builder.query({
      query: () => `driver_messages/`,
      providesTags: ['DriverMessages'],
    }),
    findDriverMessagesById: builder.query({
      query: (id) => `driver_messages/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'DriverMessages', id: result.id }]
          : ['DriverMessages'];
      },
    }),
    findDriverMessagesByUser: builder.query({
      query: () => `user_driver_messages/`,
      providesTags: ['DriverMessages'],
    }),
    createDriverMessages: builder.mutation({
      query: (data) => ({
        url: `driver_messages/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['DriverMessages'],
    }),
    updateDriverMessages: builder.mutation({
      query: ({ file, id }) => ({
        url: `driver_messages/${id}/`,
        method: 'PATCH',
        body: file,
      }),

      invalidatesTags: ['DriverMessages'],
    }),
    deleteDriverMessages: builder.mutation({
      query: (data) => ({
        url: `driver_messages/${data.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DriverMessages'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllDriverMessagesQuery,
  useFindDriverMessagesByIdQuery,
  useFindDriverMessagesByUserQuery,
  useCreateDriverMessagesMutation,
  useUpdateDriverMessagesMutation,
  useDeleteDriverMessagesMutation,
} = driverMessagesApi;
